import React, { createContext, useContext, useState, ReactNode, useEffect } from "react";
interface RoleContextType {
  role: string | undefined;
  setRole: React.Dispatch<React.SetStateAction<string>>; // Add setRole to the contex
}
const RoleContext = createContext<RoleContextType | undefined>(undefined);
interface RoleProps {
  children?: ReactNode;
}

export const useRole = () => {
  const roles = useContext(RoleContext);
  if (!roles) {
    throw new Error("useRole must be used within a RoleProvider");
  }
  return roles;
};

export const RoleProvider: React.FC<RoleProps> = ({ children }) => {
  const [role, setRole] = useState<string>("");
  useEffect(() => {
    let roleType = localStorage.getItem("Role");
    if (roleType) {
      setRole(roleType);
    }
  }, []);

  return <RoleContext.Provider value={{ role, setRole }}>{children}</RoleContext.Provider>;
};

